import { defineComponent as l, openBlock as t, createElementBlock as i, normalizeClass as a, createElementVNode as s } from "vue";
import { SfLoaderSize as e } from "@storefront-ui/shared";
const n = ["aria-label"], o = {
  [e.xs]: "h-4 w-4 ring-2",
  [e.sm]: "h-5 w-5 ring-2",
  [e.base]: "h-6 w-6 ring-2",
  [e.lg]: "h-8 w-8 ring-2",
  [e.xl]: "h-10 w-10 ring-2",
  [e["2xl"]]: "h-14 w-14 ring-[3px]",
  [e["3xl"]]: "h-24 w-24 ring-4",
  [e["4xl"]]: "h-48 w-48 ring-8"
}, c = {
  [e.xs]: "stroke-[10px]",
  [e.sm]: "stroke-[8px]",
  [e.base]: "stroke-[6px]",
  [e.lg]: "stroke-[4px]",
  [e.xl]: "stroke-[3px]",
  [e["2xl"]]: "stroke-[3px]",
  [e["3xl"]]: "stroke-2",
  [e["4xl"]]: "stroke-2"
}, k = /* @__PURE__ */ l({
  __name: "SfLoaderCircular",
  props: {
    size: {
      type: String,
      default: e.base
    },
    ariaLabel: {
      type: String,
      default: "loading"
    }
  },
  setup(r) {
    return (x, g) => (t(), i("svg", {
      class: a(["inline-block rounded-full ring-inset ring-neutral-300 text-primary-700 animate-spin-slow", o[r.size]]),
      viewBox: "25 25 50 50",
      "aria-live": "polite",
      "aria-label": r.ariaLabel,
      "data-testid": "loader-circular"
    }, [
      s("circle", {
        class: a([c[r.size], "stroke-current stroke-2 fill-none animate-stroke-loader-circular"]),
        cx: "50",
        cy: "50",
        r: "24"
      }, null, 2)
    ], 10, n));
  }
});
export {
  k as default
};
